/* eslint-disable no-nested-ternary */
import { Loader } from '@design-system/loader';
import React, { FC } from 'react';

import EmptyState from '~/components/ShoppingCart/EmptyState';

import { CartStateProps } from './models';

const CartState: FC<CartStateProps> = ({
  isCartFetching,
  isCartEmpty,
  emptyStateSettings,
}) => (
  <div>
    {isCartFetching ? (
      <div className="shopping-cart__loader">
        <Loader size="l" weight="bold" />
      </div>
    ) : isCartEmpty ? (
      <div>
        <EmptyState {...emptyStateSettings} />
      </div>
    ) : null}
  </div>
);

export default CartState;
